import { PairedCostAdjustmentType } from '@aloft/toolkit-shared';

import { FEATURE_ORDER } from '../../../../redux/constants.ts';
import { selectOrderFeatures } from '../../../../redux/features/selectors/selectOrderFeatures.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { ViewMode } from '../../types.ts';
import { FeatureDetail } from './FeatureDetail.tsx';

type FeatureDetailsProps = {
  id: string;
  viewMode: ViewMode;
};

export function FeatureDetails({ id, viewMode }: FeatureDetailsProps) {
  const orderFeatures = useAppSelector(selectOrderFeatures);

  return Object.entries(FEATURE_ORDER).flatMap(([group, features]) => {
    let newGroup = true;
    const existingFeatures = features.filter((feature) => orderFeatures.includes(feature));
    return existingFeatures.map((feature, idx) => {
      const first = newGroup;
      newGroup = false;
      return (
        <FeatureDetail
          key={`${id}-${feature}`}
          id={id}
          feature={feature}
          group={group as PairedCostAdjustmentType}
          firstInGroup={first}
          lastInGroup={idx === existingFeatures.length - 1}
          viewMode={viewMode}
        />
      );
    });
  });
}
